import React, { useState } from 'react';
import background from '../../assets/total_payments_bg.png';

import './totalPayments.css';

export default function TotalPayments({ totalPayments }) {
  const [timeframeTotalPayments, setTimeframeTotalPayments] = useState('Last 30 Days');
  const [displayTotal, setDisplayTotal] = useState(totalPayments.thirtyDays);

  const handleTimeframeSelection = (e) => {
    setTimeframeTotalPayments(e.target.innerHTML);
    switch (e.target.innerHTML) {
      case 'Last 30 Days':
        setDisplayTotal(totalPayments.thirtyDays);
        break;
      case 'Year':
        setDisplayTotal(totalPayments.year);
        break;
      case 'All Time':
        setDisplayTotal(totalPayments.allTime);
        break;
      default:
        setDisplayTotal('na');
    }
  };

  return (
    <div className="total-payments container d-flex flex-column justify-content-between py-3" style={{ backgroundImage: `url(${background})` }}>
      <div className="row no-gutters">
        <div className="col-5">
          <div
            className={timeframeTotalPayments === 'Last 30 Days' ? 'timeframe-active' : 'timeframe-inactive'}
            onClick={handleTimeframeSelection}
          >
            Last 30 Days
          </div>
        </div>
        <div className="col-3">
          <div
            className={timeframeTotalPayments === 'Year' ? 'timeframe-active' : 'timeframe-inactive'}
            onClick={handleTimeframeSelection}
          >
            Year
          </div>
        </div>
        <div className="col-4">
          <div
            className={timeframeTotalPayments === 'All Time' ? 'timeframe-active' : 'timeframe-inactive'}
            onClick={handleTimeframeSelection}
          >
            All Time
          </div>
        </div>
      </div>
      <div className="text-left">
        <p className="text-white mb-1">Total:</p>
        <h2 className="text-white">£{displayTotal}</h2>
      </div>
    </div>
  )
}
